import { mediaClient, DomainType } from "@/lib/request";
import { CommonRequestParams } from "@/types/commonParams";
import { HeadBanner, ShowCaseInfo, FloatButton } from "@/types/resource-slot";
import { ssrFetch } from "@/lib/ssrFetch";

/**
 * 资源位相关API路径
 */
const RESOURCE_API_PATHS = {
  // 营销资源位
  HOME_RESOURCE: '/fulishemini/lianmeng/home/resource',
} as const;

// 导出路径常量供外部使用
export { RESOURCE_API_PATHS };

export interface ResourceRequestParams extends CommonRequestParams {
  // _ver: string;
  // platform: number;
  // cityId: number;
  // userId: string;
  // uuid: string;
  // ctype: string;
  resourceScene: number;
}

export interface ResourceResponse {
  headBanner: HeadBanner | null;
  floatButton: FloatButton | null;
  showCaseInfo: ShowCaseInfo | null;
}

export async function getResource(params: ResourceRequestParams) {
  return mediaClient.post<ResourceRequestParams, ResourceResponse>({
    url: RESOURCE_API_PATHS.HOME_RESOURCE,
    data: params,
  });
}

/**
 * =====================================================
 * SSR兼容函数
 * =====================================================
 */

/**
 * SSR环境获取营销资源位内容
 * 与CSR完全一致的API设计：只接收一个业务参数
 * @param requestParams 请求参数（包含commonParams和业务参数）
 * @returns 资源位数据或null
 *
 * 注意: 此接口返回ResourceResponse结构,包含headBanner、floatButton、showCaseInfo等字段
 */
export async function fetchResourceForSSR(
  requestParams: ResourceRequestParams
): Promise<ResourceResponse | null> {
  const response = await ssrFetch.post<ResourceResponse, ResourceRequestParams>(
    DomainType.MEDIA,
    RESOURCE_API_PATHS.HOME_RESOURCE,
    requestParams
  );

  // 返回资源位数据,可能包含headBanner、floatButton、showCaseInfo
  return response?.data;
}
